import { render, staticRenderFns } from "./send-lottery-qualification.vue?vue&type=template&id=497a2f65&scoped=true&"
import script from "./send-lottery-qualification.vue?vue&type=script&lang=ts&"
export * from "./send-lottery-qualification.vue?vue&type=script&lang=ts&"
import style0 from "./send-lottery-qualification.vue?vue&type=style&index=0&id=497a2f65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497a2f65",
  null
  
)

export default component.exports